import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Bias-Free Scoring',
    title: 'Evaluate candidates on skills, not background',
    subtitle: 'AI-generated, role-specific rubrics score candidates against objective criteria \u2014 reducing unconscious bias and giving every applicant a fair, consistent, and explainable evaluation.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #1F4D3E 50%, #059669 100%)',
  },
  sections: [
    {
      label: 'Objective Evaluation',
      title: 'Consistent scoring, free of noise',
      features: [
        { icon: '\ud83d\udccf', title: 'AI-Generated Rubrics', desc: 'Generate a structured, role-specific scoring rubric from the job description so every candidate is judged against the same objective criteria.' },
        { icon: '\u2696\ufe0f', title: 'Bias-Free Scoring', desc: 'Scoring focuses on demonstrated skills and competencies \u2014 not names, schools, or other signals that introduce unconscious bias.' },
        { icon: '\ud83d\udd0d', title: 'Explainable Results', desc: 'Every score comes with reasoning and a skill breakdown, so decisions are transparent, auditable, and defensible.' },
        { icon: '\ud83d\udc8e', title: 'Resume Depth Analysis', desc: 'AI evaluates the true depth behind claimed skills \u2014 distinguishing genuine expertise from buzzword padding.' },
        { icon: '\ud83d\udcc8', title: 'Consistent Across Candidates', desc: 'The same rubric is applied to everyone, eliminating reviewer-to-reviewer variability and gut-feel inconsistency.' },
        { icon: '\u2705', title: 'Audit-Ready', desc: 'Transparent, rubric-based scoring creates a clear record that supports fair-hiring compliance and internal reviews.' },
      ],
      columns: 3,
    },
    {
      label: 'How It Works',
      title: 'From job description to fair score',
      desc: 'CHIRE turns your role requirements into an objective rubric, then scores every candidate against it \u2014 consistently and transparently.',
      bullets: [
        'Generate a role-specific scoring rubric from the JD',
        'AI scores candidates against the rubric\u2019s objective criteria',
        'Skill-depth analysis validates claimed expertise',
        'Each result includes reasoning and a skill breakdown',
        'The same standard is applied to every applicant',
      ],
      visual: '\u2696\ufe0f',
      visualLabel: 'Rubric-Based Scoring',
    },
    {
      label: 'For Fair Hiring',
      title: 'Diverse pipelines, defensible decisions',
      desc: 'Reduce unconscious bias and build a more diverse, qualified pipeline \u2014 with evaluations you can stand behind.',
      bullets: [
        'Focus evaluation on capability, not pedigree',
        'Consistent rubrics reduce reviewer bias',
        'Explainable scores support compliance and audits',
        'Pairs with assessments, interviews, and fraud prevention',
      ],
      visual: '\ud83c\udf31',
      visualLabel: 'Fair Evaluation Engine',
    },
  ],
  testimonial: {
    quote: 'Rubric-based, bias-free scoring made our shortlists noticeably more diverse and our decisions far easier to defend. Everyone is measured against the same objective bar.',
    name: 'Marcus L.',
    role: 'DEI & Talent Director, Brightpath',
  },
  cta: {
    title: 'Make every evaluation fair and objective',
    desc: 'AI rubrics and bias-free scoring for consistent, defensible hiring. Get started with CHIRE.',
  },
};

export default function BiasFreeScoringPage() { return <ProductPageTemplate data={DATA} />; }
